import * as React from 'react';
import { IconChevronDownSmall16, IconChevronUpSmall16, IconSuccess16, Input, Outside, Popover } from '@cian/ui-kit';

import * as styles from './suggest_input.css';
import { IRegion } from '../../types/region';

export interface ISuggestValue {
  value: number;
  label: string;
}

interface IProps {
  placeholder?: string;
  suggestions?: ISuggestValue[];
  loading?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
  valueNotFound?: React.ReactNode;
  width?: number;
  region?: IRegion;

  onSelect(value: number): void;
}

export const SuggestInput = ({
  placeholder,
  suggestions,
  region,
  loading,
  disabled,
  width = 150,
  isInvalid,
  valueNotFound,
  onSelect,
}: IProps) => {
  const [isOpened, setIsOpened] = React.useState(false);
  // undefined для корректной работы defaultValue
  const [value, setValue] = React.useState('');

  const contentRef = React.createRef<HTMLDivElement>();
  const inputRef = React.createRef<HTMLInputElement>();

  const onClose = React.useCallback(() => {
    setIsOpened(false);
    setValue('');
  }, []);

  const onOpen = React.useCallback(() => {
    setIsOpened(true);
  }, []);

  const selectItem = React.useCallback(
    (id: number) => {
      onSelect(id);
      onClose();
    },
    [onClose, onSelect],
  );

  const onValueChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setValue(value);
  }, []);

  const filteredSuggestions = React.useMemo(() => {
    return suggestions?.filter(item => item.label.match(new RegExp(value, 'i')));
  }, [suggestions, value]);

  return (
    <Popover
      placement="bottom-start"
      open={isOpened}
      content={
        <Outside active={isOpened} onOutside={onClose} insideRefs={[contentRef, inputRef]}>
          <div style={{ width }} ref={contentRef} className={styles['list']}>
            {filteredSuggestions?.map(item => (
              <div
                data-name="PopupListItem"
                className={styles['list-item']}
                key={item.value}
                onClick={() => selectItem(item.value)}
              >
                <div className={styles['checked']}>
                  {item.value === region?.id && <IconSuccess16 color="primary_100" />}
                </div>
                <span>{item.label}</span>
              </div>
            ))}
            {!filteredSuggestions?.length && valueNotFound}
          </div>
        </Outside>
      }
    >
      <Input
        ref={inputRef}
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        invalid={isInvalid}
        value={isOpened ? value : region?.displayName}
        onChange={onValueChange}
        onFocus={onOpen}
        width={width}
        maxWidth={500}
        rightAdornment={
          isOpened ? (
            <span onClick={onClose} className={styles['icon']}>
              <IconChevronUpSmall16 color="primary_100" />
            </span>
          ) : (
            <span onClick={onOpen} className={styles['icon']}>
              <IconChevronDownSmall16 color="primary_100" />
            </span>
          )
        }
      />
    </Popover>
  );
};
